import { z } from 'zod';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^\d+$/;

export const loginSchema = z
	.object({
		grantType: z.enum(['email', 'phone']),
		email: z.string().trim().optional(), // optional로 유지
		phone: z.string().trim().optional(), // 여기서도 optional
		password: z.string().trim(),
	})
	// 이메일 로그인일 때: 이메일 값 존재 + 포맷 체크
	.refine(
		data =>
			data.grantType !== 'email' ||
			(!!data.email && emailRegex.test(data.email)),
		{
			message: 'Please enter a valid email format',
			path: ['email'],
		}
	)
	// 폰 로그인일 때: 숫자만 + 길이 8 이상
	.refine(
		data =>
			data.grantType !== 'phone' ||
			(!!data.phone && phoneRegex.test(data.phone)),
		{
			message: 'Phone number must contain digits only.',
			path: ['phone'],
		}
	)
	.refine(
		data => data.grantType !== 'phone' || (data.phone?.length ?? 0) >= 8,
		{
			message: 'Phone number must be at least 8 digits long.',
			path: ['phone'],
		}
	)
	// 패스워드 항상 필수
	.refine(data => data.password.length >= 6, {
		message: 'Password must be at least 6 characters long.',
		path: ['password'],
	});
